'use client';

import { c as _c } from "react/compiler-runtime";
import { type ReactNode } from 'react';
import { Button } from '../../../button/button';
import { ButtonVariant } from '../../../button/buttonVariant';
import { Close } from '../../../svgs';
import styles from './web-prompt.module.scss';
type WebPromptProps = {
  bodyLabel: string;
  closeLabel: string;
  installBtnLabel: string;
  logo: ReactNode;
  onAccept: () => void;
  onClose: () => void;
};
export const WebPrompt = t0 => {
  const $ = _c(14);
  const {
    bodyLabel,
    closeLabel,
    installBtnLabel,
    logo,
    onAccept,
    onClose
  } = t0;
  let t1;
  if ($[0] !== bodyLabel) {
    t1 = <p className={styles.prompt__message}>{bodyLabel}</p>;
    $[0] = bodyLabel;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== installBtnLabel || $[3] !== onAccept) {
    t2 = <Button className={styles["prompt__install-button"]} onClick={onAccept}>{installBtnLabel}</Button>;
    $[2] = installBtnLabel;
    $[3] = onAccept;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Close />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== closeLabel || $[7] !== onClose) {
    t4 = <Button aria-label={closeLabel} className={styles["prompt__close-button"]} onClick={onClose} variant={ButtonVariant.Secondary}>{t3}</Button>;
    $[6] = closeLabel;
    $[7] = onClose;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== logo || $[10] !== t1 || $[11] !== t2 || $[12] !== t4) {
    t5 = <div className={styles["prompt-wrapper"]}><div className={styles.prompt}>{logo}{t1}{t2}{t4}</div></div>;
    $[9] = logo;
    $[10] = t1;
    $[11] = t2;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};